import React, { useEffect, useState } from "react";
import { Tree } from "./components/Tree";
import "./styles.less";
import { tryNow } from "../../utils";
import { useTranslation } from "react-i18next";

export const MenuTree = (props) => {
  const { dataSource, user } = props;
  const { t } = useTranslation();

  return (
    <div className="top-nav-menu-tree">
      <div className="mobile-nav-menu-wrap">
        <Tree data={dataSource} isRoot={true} />
        <div className="immediately-warp">
          {user ? (
            <div
              className="immediately-logout-button"
              onClick={() => {
                window.location.href = "/logout";
              }}
            >
              {t("common.nav.nav-logout")}
            </div>
          ) : (
            <div className="immediately-login-button" onClick={tryNow}>
              {t("common.nav.nav-mobile-login")}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

MenuTree.defaultProps = {
  dataSource: [],
};
